var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FutureAddressFormGroup',_vm._g({},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }